<template>
<div class="chapter">
<div class="inner_page">
<h2 class="partlabel"><a id="page_1"></a><span class="small">PART ONE</span></h2>
<h2 class="parttitle">How a Liberal Christian Looks at Religion</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_08_part01.vue?030aff7c